import React, {useState, useEffect} from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect } from 'react-redux'
import { 
  LockFilled,
  QuestionCircleOutlined, 
  LogoutOutlined 
} from '@ant-design/icons';
import Icon from 'components/util-components/Icon';
import { signOut } from 'redux/actions/Auth';
import { useHistory } from "react-router-dom";
const menuItem = [
  {
    title: "Alterar Senha",
    icon: LockFilled ,
    path: "/app/alterar-senha"
  },
  {
    title: "Fale Conosco",
    icon: QuestionCircleOutlined,
    path: "/auth/fale-conosco"
	}
]

export const NavProfile = ({signOut}) => {
  let history = useHistory();
  const profileImg = "/img/avatars/thumb-8.jpg";
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="text-center">
          <Avatar size={65} src={profileImg} />
          <div className="pt-2">
            <h4 className="mb-0">{ localStorage.getItem("usuario_nome") }</h4>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {!localStorage.getItem("adm") ? menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <a href={el.path}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </a>
              </Menu.Item>
            );
          }) : null}
          <Menu.Item key={menuItem.legth + 1} onClick={e => {history.push('/auth')}}>
            <span>
              <LogoutOutlined className="mr-3"/>
              <span className="font-weight-normal">Sair</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );

  const [token, setToken] = useState('');

  useEffect(() => {
    setToken(localStorage.getItem('auth_token'));
  }, []);

  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item>
          <Avatar src={profileImg} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}

export default connect(null, {signOut})(NavProfile)
